import { CITY_SLUG } from 'dpl/constants/query_params';

const DEFAULT_RESOURCE_DEFINITION = {
  defaultValue: {
    meta: {},
    data: []
  }
};

export function breederProfilesResourceDefinition(
  breedId,
  itemsPerPage,
  currentPage,
  filters
) {
  return {
    url: `/api/breeds/${breedId}/breeder_profiles/index_v2.json`,
    params: {
      per_page: itemsPerPage,
      page: currentPage,
      ...filters
    },
    defaultValue: {
      meta: {
        available_delivery_methods: []
      },
      data: []
    }
  };
}

export function resultMediaResourceDefinition(breedId, breederProfileId) {
  return {
    url: `/api/breeder_profiles/${breederProfileId}/breeds/${breedId}/result_media.json`,
    params: {},
    defaultValue: {
      result_photos: [],
      result_video: null
    }
  };
}

export function breedDescriptionResourceDefinition(breedId) {
  return {
    url: `/api/breeds/${breedId}/descriptions.json`,
    params: {},
    defaultValue: {
      meta: {},
      data: []
    }
  };
}

export function faqsResourceDefinition(breedId, citySlug) {
  return {
    url: `/api/breeds/${breedId}/city_faqs.json`,
    params: {
      city_slug: citySlug
    },
    defaultValue: {
      meta: {},
      data: []
    }
  };
}

export function healthTiersResourceDefinition() {
  return {
    url: '/api/options/health_tiers.json',
    ...DEFAULT_RESOURCE_DEFINITION
  };
}

export function featuredBreederProfilesResourceDefinition(breedId, citySlug) {
  return {
    url: `/api/breeds/${breedId}/featured_breeder_profiles.json`,
    params: { [CITY_SLUG]: citySlug },
    defaultValue: {
      data: []
    }
  };
}
